import React from "react";
import BottomSheet from "../ui/BottomSheet";
import "@/assets/css/BranchMap.css";
import { Address } from "@/types/branch";
import LocationIcon from "@/assets/img/LocationIcon";
import PhoneIcon from "@/assets/img/PhoneIcon";
import Button from "../ui/Button";
import MobileOperationalTimes from "./MobileOperationalTimes";

interface RestaurantDetailsProps {
  isModalOpen: boolean;
  handleModalClose: () => void;
  address?: Address; // Make address optional to handle undefined scenarios
  phoneNumber?: string;
  aiAgentPhoneNumber?: string;
  branchName?: string;
  operatingHours?: any;
}

const RestaurantDetails: React.FC<RestaurantDetailsProps> = ({
  isModalOpen,
  handleModalClose,
  address,
  phoneNumber,
  aiAgentPhoneNumber,
  branchName,
  operatingHours,
}) => {
  if (!address) {
    return (
      <BottomSheet isOpen={isModalOpen} onClose={handleModalClose}>
        <p>No address information available.</p>
      </BottomSheet>
    );
  }

  console.log(aiAgentPhoneNumber);

  const fullAddress = `${address.street}, ${address.city}, ${address.province} ${address.postal_code}, ${address.country}`;
  const { latitude, longitude } = address;

  return (
    <BottomSheet
      isOpen={isModalOpen}
      onClose={handleModalClose}
      customStyles={{ maxHeight: "93vh", overflowY: "hidden" }}
    >
      <div className="flex flex-col justify-between h-full">
        <div>
          <div className="relative w-full h-[200px] overflow-hidden">
            <iframe
              width="100%"
              height="100%"
              title="Branch Location Map"
              style={{ border: 0 }}
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAnVKeSTixBr0zPPECufZ1qoU6dEsfPF5o&q=${latitude},${longitude}`}
              allowFullScreen
            ></iframe>
          </div>
          <div className="flex items-center justify-between mt-5 mx-5 mb-2">
            <p className="text-2xl font-bold">{branchName}</p>
            <button onClick={handleModalClose}>
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="#3D3D3D"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex items-center mx-5">
            <LocationIcon className="mr-2" />
            <p className="text-xs font-normal">{fullAddress}</p>
          </div>
          <div className="flex items-center mx-5 mt-2">
            <PhoneIcon className="w-3 h-3 mr-2" />
            kasjdkasj
            <p className="text-xs font-normal">
              {aiAgentPhoneNumber ? aiAgentPhoneNumber : phoneNumber}
            </p>
          </div>
          <div className="mx-5 mt-5">
            <p className="font-bold text-base">Business Hours</p>
            <MobileOperationalTimes operatingHours={operatingHours} />
          </div>
        </div>

        <div className="flex w-full items-center justify-center mb-10">
          <Button
            variant="primary"
            text="Close"
            className="w-[90%] h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px] 
                    text-[16px] md:text-[18px] font-bold flex items-center justify-center"
            onClick={handleModalClose}
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default RestaurantDetails;
